import {Component, Input, Output, EventEmitter, ViewEncapsulation, AfterViewInit} from '@angular/core';

@Component({
  selector: 'progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class ProgressBarComponent implements AfterViewInit {


  //@Input() public height: string = '';
  @Input() public progress: number;
  @Input() public average: number;
  @Input() public cut: number;


  constructor() { }

  ngAfterViewInit(): void {
  }



}
